import { Container } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import HomeInspectorConfirmation from "./../../../assets/images/HomeInspectorConfirmation.png";

const Success = () => {
    const navigate = useNavigate();

    const handleGetQualifiedClick = () => {
        navigate("/properties");
    };

    return (
        <>
            <div className="tw-min-h-screen tw-h-full tw-pt-[65px]  tw-bg-background_color tw-overflow-hidden">
                <span className="">
                    <Header title="Apply For Financing" />
                </span>

                <div className="tw-max-w-full tw-h-full  tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-between ">
                    <div></div>
                    <div className="tw-flex  tw-flex-col tw-max-w-[70%] max-sm:tw-max-w-[100%] tw-bg-white max-sm:tw-bg-transparent tw-rounded-xl tw-w-full ">
                        <div className="tw-flex tw-justify-center tw-mt-3">
                            <img src={HomeInspectorConfirmation} className="tw-w-[150px]" alt="" />
                        </div>

                        <div className="tw-rounded-lg tw-py-8 tw-flex tw-flex-col tw-gap-5 max-md:tw-px-8 tw-px-16 max-sm:tw-px-5 ">
                            <div className="tw-text-center">
                                <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-2 ">Great job!</h1>
                                <p className="tw-text-gray-600 tw-text-[16px] tw-font-medium">
                                    Your information is having a brief review—everything’s on track!{" "}
                                </p>
                            </div>

                            <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                                <button
                                    onClick={() => {
                                        // Clean up all GetQualified form data
                                        localStorage.removeItem("getQualified_generalInfo");
                                        localStorage.removeItem("getQualified_stepTwo");
                                        sessionStorage.removeItem("insuranceInfo");
                                        navigate("/properties");
                                    }}
                                    className="tw-bg-primary hover:tw-bg-primary_hover tw-text-nowrap tw-w-fit tw-px-[100px] max-sm:tw-px-[30px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                                >
                                    Return To Home Screen
                                </button>
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
                {/* <div className="tw-max-w-full  tw-mt-[55px] tw-mx-auto ">
                    <div className="tw-flex tw-justify-center tw-mt-8">
                        <img src={HomeInspectorConfirmation} className="tw-w-[200px]" alt="" />
                    </div>

                    <div className="tw-rounded-lg tw-py-8 max-md:tw-px-8 tw-px-24 max-sm:tw-px-5 ">
                        <div className="tw-text-center tw-mb-8 ">
                            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-2 ">Great Job</h1>
                            <p className="tw-text-gray-600 tw-text-[16px] tw-font-bold">
                                Your information is having a brief review—everything’s on track!{" "}
                            </p>
                        </div>

                        <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                            <button
                                onClick={handleGetQualifiedClick}
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-w-fit tw-px-[100px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                            >
                                Return To Home Screen
                            </button>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
};

export default Success;
